import { NextRouter } from 'next/router';
import { init, initNextJsTrackPageview, PlatformName } from '@cbhq/client-analytics';

import { getStaticConfig, isProduction } from ':support/config';

export function initClientAnalytics(router: NextRouter) {
  const { amplitudeApiKey, appVersion } = getStaticConfig();

  if (window !== undefined) {
    init({
      isProd: isProduction(),
      amplitudeApiKey,
      platform: PlatformName.web,
      projectName: 'cdp_support_hub',
      showDebugLogging: false,
      version: appVersion,
    });

    initNextJsTrackPageview({
      nextJsRouter: router,
    });
  }
}
